const __WEBPACK_NAMESPACE_OBJECT__ = require("userful-chronos-common-store/dist/config");